import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpRequest
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { SessionService } from "../services/session.service";
import { toastrService } from "../services/ux/toastr.service";
import { TranslateService } from "@ngx-translate/core";

@Injectable()
export class LogoutInterceptorService {
  constructor(private session: SessionService, private toastr: toastrService, private translateService: TranslateService) {}
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // * Intercpet response to logout the user
    return next.handle(req).pipe(
      catchError((errorResponse: HttpErrorResponse) => {
        if (errorResponse.status === 401 && !errorResponse.url.includes("api/otp/verifyCode")) {
          this.toastr.info(this.translateService.instant("LogoutMiddleware.Text"));
          this.session.logout();
          window.location.reload();
          return;
        }
        return throwError(errorResponse);
      })
    );
  }
}
